import { NgModule } from '@angular/core';
import { IsAppEnabledForAdminPipe } from './is-app-enabled-for-admin.pipe';

@NgModule({
    declarations: [IsAppEnabledForAdminPipe],
    exports: [IsAppEnabledForAdminPipe],
})
export class IsAppEnabledForAdminPipeModule {}
